/* eslint-disable import/no-named-as-default */
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  mobile: {
    marginTop: 8,
  },
  desktop: {
    display: "none",
  },
  sectionTitle: {
    textDecoration: "none",
  },
  logoImg: {
    height: 120,
  },
  typoLink: {
    fontSize: 15,
    textDecoration: "none",
    display: "block",
    color: "#3D3C3C",
  },
  paymentMethodLogo: {
    padding: 10,
    height: 48,
  },
  "@media (min-width: 1024px)": {
    mobile: {
      display: "none",
    },
    desktop: {
      display: "flex",
    },
    root: {
      width: "100%",
      marginTop: 20,
      backgroundColor: theme.palette.background.paper,
    },
    disclaimer: {
      textAlign: "center",
      padding: theme.spacing(2),
    },
    inner: {
      width: 1000,
      marginLeft: "auto",
      marginRight: "auto",
    },
    footer: {
      marginTop: 35,
      padding: `${theme.spacing(2)}px 0`,
    },
  },
});

const cdnPaymentsBaseUrl =
  "https://sportyshop.s3.eu-west-2.amazonaws.com/catalog/common";

class CatalogFooter extends React.Component {
  render() {
    const { classes } = this.props;

    const footers = [
      {
        title: "יצירת קשר",
        key: "contact",
        content: (
          <Typography className={classes.sectionTitle} component="p">
            איתמר: 054-9200911 <br />
            מארק: 058-4453700 <br />
            פקס: 077-3181220 <br />
            מספר עוסק: 03696453-4 <br />
            דוא״ל:{" "}
            <a
              className={classes.sectionTitle}
              href="mailto: service@sportyshop.co.il"
            >
              service@sportyshop.co.il
            </a>
          </Typography>
        ),
      },
      {
        title: "מידע כללי",
        key: "sitemap",
        description: [
          {
            key: "about-link",
            text: "אודות ספורטישופ",
            url: "/about-us",
          },
          {
            key: "returns-and-refund-policy",
            text: "מדיניות החזרות והחזר כספי",
            url: "returns-and-refund-policy",
          },
          {
            key: "shops-footer-link",
            text: "נקודות התקנת צמיגים",
            url: "/our-shops",
          },
          {
            key: "shops-signup",
            text: "הצטרפות כנקודת התקנה",
            url: "/shop/signup",
          },
          {
            key: "imprint",
            text: "פרטים משפטיים",
            url: "/imprint",
          },
          // {
          //     text: 'עזרה ומידע',
          //     url: '/tires/help-center'
          // },
          {
            key: "tou",
            text: "תנאי השימוש בשירות",
            url: "/terms-of-use",
          },
          {
            key: "privacy-policy",
            text: "הצהרת פרטיות",
            url: "/privacy-policy",
          },
          {
            key: "accessibility",
            text: "הצהרת נגישות",
            url: "/accessibility-policy",
          },
          {
            key: "gdpr-statement",
            text: "הצהרת הגנת מידע (GDPR)",
            url: "/data-protection-policy-and-gdpr",
          },
        ],
      },
      {
        key: "fields",
        title: "מידע נוסף",
        description: [
          {
            key: "fbpage",
            text: "עקבו אחרינו בפייסבוק",
            external: true,
            url: "https://www.facebook.com/sportyshop.moto",
          },
        ],
      },
      {
        key: "logos",
        title: "אמצעי תשלום מכובדים",
        content: (
          <table>
            <tbody>
              <tr>
                <td>
                  <img
                    alt="We accept MasterCard!"
                    className={classes.paymentMethodLogo}
                    src={`${cdnPaymentsBaseUrl}/mastercard.png`}
                  />
                </td>
                <td>
                  <img
                    alt="We accept Visa!"
                    className={classes.paymentMethodLogo}
                    src={`${cdnPaymentsBaseUrl}/visa.png`}
                  />
                </td>
                <td>
                  <img
                    alt="We accept PayPal"
                    className={classes.paymentMethodLogo}
                    src={`${cdnPaymentsBaseUrl}/paypal.png`}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        ),
      },
    ];

    return (
      <footer className={classNames(classes.footer, classes.layout)}>
        <div className={classes.inner}>
          <Grid
            container
            spacing={6}
            justifyContent="space-evenly"
            className={classes.desktop}
          >
            {footers.map((footer) => (
              <Grid item xs key={footer.key}>
                {footer.title && (
                  <Typography
                    variant="h6"
                    gutterBottom
                    className={classes.sectionTitle}
                  >
                    {footer.title}
                  </Typography>
                )}
                {footer.description &&
                  footer.description.map((item) => {
                    return (
                      <React.Fragment key={item.key}>
                        {item.external === undefined && (
                          <Typography
                            component={Link}
                            to={item.url}
                            variant="body2"
                            className={classes.typoLink}
                          >
                            {item.text}
                          </Typography>
                        )}

                        {item.external && item.external === true && (
                          <Typography
                            className={classes.typoLink}
                            component="a"
                            href={item.url}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            {item.text}
                          </Typography>
                        )}
                      </React.Fragment>
                    );
                  })}
                {footer.content !== undefined && footer.content}
              </Grid>
            ))}
          </Grid>
        </div>

        <div className={classes.mobile}>
          <Grid container spacing={2} justifyContent="flex-start">
            {footers.map((footer) => (
              <Grid item sm={6} key={footer.key}>
                {footer.title && (
                  <Typography
                    variant="h6"
                    gutterBottom
                    className={classes.sectionTitle}
                  >
                    {footer.title}
                  </Typography>
                )}
                {footer.description &&
                  footer.description.map((item) => {
                    return (
                      <React.Fragment key={item.url}>
                        {item.external === undefined && (
                          <Typography
                            component={Link}
                            to={item.url}
                            variant="body2"
                            className={classes.typoLink}
                          >
                            {item.text}
                          </Typography>
                        )}

                        {item.external && item.external === true && (
                          <Typography
                            className={classes.typoLink}
                            component="a"
                            href={item.url}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            {item.text}
                          </Typography>
                        )}
                      </React.Fragment>
                    );
                  })}
                {footer.content !== undefined && footer.content}
              </Grid>
            ))}
          </Grid>
        </div>
      </footer>
    );
  }
}

CatalogFooter.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(CatalogFooter);
